import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext();

export function CartProvider({ children }) {

  const [cartIds, setCartIds] = useState(() => {
    return JSON.parse(localStorage.getItem("cart")) || [];
  });

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cartIds));
  }, [cartIds]);

  const addToCart = (productId) => { 
    if (cartIds.includes(productId)) {
      return false;
    }

    setCartIds((prev) => [...prev, productId]);

    return true;
  };

  const removeItem = (productId) => {
    setCartIds((prev) =>
      prev.filter((id) => Number(id) !== Number(productId))
    );
  };

  const cartCount = cartIds.length;

  return (
    <CartContext.Provider
      value={{
        cartIds,
        cartCount,
        addToCart,
        removeItem,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);

